import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';




@NgModule({
  declarations: [],
  imports: [
    CommonModule, ToastrModule.forRoot(), NgxUiLoaderModule
  ],
  exports: [
    ToastrModule,
    NgxUiLoaderModule
  ]
})
export class CoreModule { }
